// src/components/Calendar/CalendarView.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import '../css/CalendarView.css';

const CalendarView = () => {
    const [entries, setEntries] = useState([]);
    const [currentMonth, setCurrentMonth] = useState(dayjs());

    useEffect(() => {
        const fetchEntries = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/calendar`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                });
                setEntries(response.data);
            } catch (error) {
                console.error('Error fetching calendar entries:', error);
            }
        };
        fetchEntries();
    }, []);

    const daysInMonth = currentMonth.daysInMonth();
    const startOfMonth = currentMonth.startOf('month').day();

    const getDayEntries = (date) => entries.filter(entry => entry.date === date);

    const handlePrevMonth = () => setCurrentMonth(currentMonth.subtract(1, 'month'));
    const handleNextMonth = () => setCurrentMonth(currentMonth.add(1, 'month'));

    return (
        <div className="calendar-view-container">
            <h2>Calendar</h2>
            <div className="calendar-navigation">
                <button onClick={handlePrevMonth}>Previous</button>
                <span>{currentMonth.format('MMMM YYYY')}</span>
                <button onClick={handleNextMonth}>Next</button>
            </div>
            
            <div className="calendar-grid">
                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                    <div key={day} className="calendar-day-header">{day}</div>
                ))}
                
                {Array.from({ length: startOfMonth }).map((_, index) => (
                    <div key={index} className="calendar-empty-day"></div>
                ))}

                {Array.from({ length: daysInMonth }).map((_, dayIndex) => {
                    const date = currentMonth.date(dayIndex + 1).format('YYYY-MM-DD');
                    const dayEntries = getDayEntries(date);
                    return (
                        <div key={date} className="calendar-day">
                            <span className="calendar-date">{dayIndex + 1}</span>
                            {dayEntries.map(entry => (
                                <div key={entry.id} className="calendar-entry">
                                    <h4>{entry.title}</h4>
                                    <p>{entry.description}</p>
                                </div>
                            ))}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CalendarView;
